export { UserDetailsSkeleton } from './UserDetailsSkeleton';
